module.exports = __webpack_public_path__ + "media/stable/components/site/place_hero/assets/curbed-5256a4a8067d4fc672536cfc43b5004c.png";